import { companyApis } from '@apis/dashboard/companyApis';
import { useQuery } from '@hooks/useQuery';

export const useCompanyPrincipal = (id: number) => {
  return useQuery([`/dashboard/company/${id}/owner/`], () =>
    companyApis
      .get('/dashboard/company/{id}/owner/', {
        path: { id },
      })
      .then((r) => r[200]!),
  );
};
